
import React from "react";
import { Button } from "@/components/ui/button";
import { MessageSquareReply, Star } from "lucide-react";
import { usePermissions } from "@/context/PermissionsContext";

interface MessageActionsProps {
  isOwnMessage: boolean;
  hasReacted: boolean;
  reactionCount: number;
  onReply: () => void;
  onToggleReaction: () => void;
}

const MessageActions: React.FC<MessageActionsProps> = ({
  isOwnMessage,
  hasReacted,
  reactionCount,
  onReply,
  onToggleReaction,
}) => {
  const { hasPermission } = usePermissions();
  const canWriteFeedback = hasPermission("feedback", "write");

  return (
    <div className="flex justify-between px-4 py-2 border-t">
      <div className="flex gap-2">
        {canWriteFeedback && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onReply}
            className="text-muted-foreground hover:text-primary hover:bg-primary/10"
          >
            <MessageSquareReply className="h-4 w-4 mr-1" />
            Reageren
          </Button>
        )}
        <Button
          variant={hasReacted ? "default" : "ghost"}
          size="sm"
          onClick={onToggleReaction}
          className={hasReacted ? "bg-amber-500 hover:bg-amber-600" : "text-muted-foreground"}
        >
          <Star className="h-4 w-4 mr-1" />
          {reactionCount > 0 && reactionCount}
        </Button>
      </div>
    </div>
  );
};

export default MessageActions;
